module.exports = __webpack_public_path__ + "img/1535523168.7e25a1b0.jpg";